export default __webpack_public_path__ + "static/media/gmall-logo-text.7bf6b6b4.svg";